import { APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";

interface IGetFacilityIntegrations {
  id?: string | number;
}

//GET Facility Integrations
export async function GetFacilityIntegrations(params: IGetFacilityIntegrations, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/facility/integration"), params, useGlobalLoader);
}

//POST Facility Integration
interface IPostFacilityIntegration {
  external_client_id: number;
}

export async function PostFacilityIntegration(params: IPostFacilityIntegration, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/integration"), params, useGlobalLoader);
}

//PUT Facility Integration
export interface IPutFacilityIntegration {
  id: string | number;
  username?: string;
  password?: string;
  base_url?: string;
  backup_base_url?: string;
}

export async function PutFacilityIntegration(params: IPutFacilityIntegration, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/integration"), params, useGlobalLoader);
}

interface IGetExternalClients {
  id?: string | number;
}

//GET External Clients
export async function GetExternalClients(params: IGetExternalClients, useGlobalLoader: boolean) {
  return await APIGet(
    APIUrl(AdminType.FacilityAdmin, "/facility/integration/external-client"),
    params,
    useGlobalLoader,
  );
}
